/**
 * Spodní dok – šipka Na začátek a její soužití s bublinou Poradny (viz snippets/spodni-dok.liquid,
 * assets/component-spodni-dok.css).
 *
 *   - šipka se ukáže po odrolování dvou výšek okna; stav se zrcadlí i třídou ml-nahoru-videt na
 *     body, podle které CSS zvedne bublinu Poradny nad šipku (veřejná proměnná appky);
 *   - otevření a zavření chatu (události notia-advisor:open/close) přepíná třídu ml-chat-otevren,
 *     šipka se při otevřeném chatu schová;
 *   - tlačítka Poradny v motivu ([data-ml-poradna], lepicí lišta) jsou v markupu skrytá a odkryjí
 *     se, až je chat appky k dispozici – bez embedu by klik nic neudělal.
 */
(function () {
  var body = document.body;
  var b = document.querySelector('.ml-nahoru');

  if (b) {
    var cekani = false;
    var obnov = function () {
      cekani = false;
      var videt = window.scrollY >= window.innerHeight * 2;
      if (videt === !b.hidden) return;
      b.hidden = !videt;
      body.classList.toggle('ml-nahoru-videt', videt);
    };
    var naplanuj = function () {
      if (!cekani) { cekani = true; requestAnimationFrame(obnov); }
    };
    window.addEventListener('scroll', naplanuj, { passive: true });
    window.addEventListener('resize', naplanuj);
    b.addEventListener('click', function () {
      var plynule = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: 0, behavior: plynule ? 'smooth' : 'auto' });
    });
    obnov();
  }

  document.addEventListener('notia-advisor:open', function () { body.classList.add('ml-chat-otevren'); });
  document.addEventListener('notia-advisor:close', function () { body.classList.remove('ml-chat-otevren'); });

  function odkryjPoradnu() {
    document.querySelectorAll('[data-ml-poradna]').forEach(function (el) { el.hidden = false; });
  }
  if (window.NotiaAdvisor) odkryjPoradnu();
  else document.addEventListener('notia-advisor:ready', odkryjPoradnu, { once: true });
})();
